import { render, staticRenderFns } from "./SessionPage.vue?vue&type=template&id=0ab19880&scoped=true"
import script from "./SessionPage.vue?vue&type=script&lang=js"
export * from "./SessionPage.vue?vue&type=script&lang=js"
import style0 from "./SessionPage.vue?vue&type=style&index=0&id=0ab19880&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab19880",
  null
  
)

export default component.exports